<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  
  <!-- Content -->
  <div class="flex flex-1 overflow-hidden justify-content-center align-items-center h-full mb-2">
    <p>{{ 'global.site_not_found_message' | translate }}</p>
  </div>
</div>
